import { useQuery } from '@apollo/client';
import { gql } from '../graphql/generated';
import useIsPublicView from '../utils/useIsPublicView';

const POST_TITLE_QUERY = gql(/** @complexity 1 */ `
  query CachedPostTitle($id: ID!) {
    post(id: $id) {
      id
      title
    }
  }
`);

const PUBLIC_POST_TITLE_QUERY = gql(/** @complexity 1 */ `
  query cachedPublicPostTitle($id: ID!) {
    post: publicPost(id: $id) {
      id
      title
    }
  }
`);

const useCachedPostTitle = (postId: string) => {
  const isPublicView = useIsPublicView();

  const { data } = useQuery(POST_TITLE_QUERY, {
    variables: { id: postId },
    fetchPolicy: 'cache-only',
    skip: isPublicView,
  });

  const { data: publicData } = useQuery(PUBLIC_POST_TITLE_QUERY, {
    variables: { id: postId },
    fetchPolicy: 'cache-only',
    skip: !isPublicView,
  });

  return (data ?? publicData)?.post?.title;
};

export default useCachedPostTitle;
